<template>
  <el-date-picker
    v-model="defaultValue"
    type="month"
    :name="name"
    @change="onMonthChange"
    value-format="yyyy-MM"
    placeholder="Selecione">
  </el-date-picker>
</template>

<script>
export default {
  props: ['value', 'name', 'url', 'noDate'],
  data() {
    return {
      defaultValue: this.value
        ? this.value
        : this.noDate ? null : window.moment().format('YYYY-MM')
    };
  },
  mounted() {
    // console.log('Component mounted.');
  },
  methods: {
    onMonthChange(newValue) {
      var url = this.url + '&fecha=' + newValue;
      window.location.href = url;
    }
  }
};
</script>
